// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roboto Condensed supports both Cyrillic and Latin, so RU/EN use identical metrics. */
:root {
  --font-cyberfit: "Roboto Condensed", "Arial Narrow", "Segoe UI", Arial, sans-serif;
  --font-mono: "JetBrains Mono", "Fira Code", Consolas, monospace;
  min-height: 100vh;
  height: 100%;
  line-height: 1.5;
  font-weight: 400;
  margin: 0 auto;

  /* CyberFit core palette */
  --color-ink: #1F1A16;
  --color-midnight: #0F1C26;
  --color-panel-dark: #132635;
  --color-blue-steel: #1D3443;
  --color-parchment: #E5D1AB;
  --color-paper: #D8BF92;
  --color-ivory: #F4E7CA;
  --color-muted: #9B876A;
  --color-hero: #BE4D34;
  --color-hero-dark: #8F2F24;
  --color-danger: #A83222;
  --color-copper: #C45235;
  --color-guide: #4D7E88;
  --color-guide-bright: #4E91A1;
  --color-guide-dark: #3F7380;
  --color-energy: #5CCCF4;
  --color-gold: #B58A43;
  --color-gold-light: #D0A85A;
  --color-brass: #8D6A35;
  --color-success: #5C765D;
  --color-disabled: #B7A383;

  /* Backward-compatible project variables */
  --font: var(--color-ink);
  --bcg: var(--color-parchment);
  --button: var(--color-midnight);
  --pink: var(--color-danger);
  --page: var(--color-paper);
  --yellow: var(--color-gold-light);

  color: var(--color-ink);
  background: var(--color-parchment);
  color-scheme: light;
}

html,
body,
#root {
  min-height: 100%;
  margin: 0;
}

html {
  background-color: var(--color-midnight);
}

body {
  font-family: var(--font-cyberfit);
  color: var(--color-ink);
  background-color: var(--color-parchment);
  background-image:
    radial-gradient(circle at 18% 12%, rgba(181, 138, 67, 0.14), transparent 34%),
    radial-gradient(circle at 82% 88%, rgba(190, 77, 52, 0.10), transparent 32%),
    linear-gradient(135deg, rgba(244, 231, 202, 0.24), rgba(216, 191, 146, 0.16));
  background-attachment: fixed;
}

button,
input,
select,
textarea {
  font: inherit;
}


/* Unified bilingual typography and overflow protection. */
*,
*::before,
*::after {
  box-sizing: border-box;
}

:where(h1, h2, h3, h4, h5, h6, p, li, label, button, a) {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: normal;
  hyphens: auto;
}

:where(h1, h2, h3, h4, h5, h6, button) {
  text-wrap: balance;
}

:where(img, svg, video, canvas) {
  max-width: 100%;
}

::selection {
  color: var(--color-ivory);
  background: var(--color-hero);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,uFAAuF;AACvF;EACE,kFAAkF;EAClF,+DAA+D;EAC/D,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;;EAEd,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;;EAEzB,0CAA0C;EAC1C,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;;EAEjC,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,wCAAwC;EACxC;;;iFAG+E;EAC/E,4BAA4B;AAC9B;;AAEA;;;;EAIE,aAAa;AACf;;;AAGA,0DAA0D;AAC1D;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+EAA+E;AACjF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;400;500;600;700;800;900&display=swap\");\n\n/* Roboto Condensed supports both Cyrillic and Latin, so RU/EN use identical metrics. */\n:root {\n  --font-cyberfit: \"Roboto Condensed\", \"Arial Narrow\", \"Segoe UI\", Arial, sans-serif;\n  --font-mono: \"JetBrains Mono\", \"Fira Code\", Consolas, monospace;\n  min-height: 100vh;\n  height: 100%;\n  line-height: 1.5;\n  font-weight: 400;\n  margin: 0 auto;\n\n  /* CyberFit core palette */\n  --color-ink: #1F1A16;\n  --color-midnight: #0F1C26;\n  --color-panel-dark: #132635;\n  --color-blue-steel: #1D3443;\n  --color-parchment: #E5D1AB;\n  --color-paper: #D8BF92;\n  --color-ivory: #F4E7CA;\n  --color-muted: #9B876A;\n  --color-hero: #BE4D34;\n  --color-hero-dark: #8F2F24;\n  --color-danger: #A83222;\n  --color-copper: #C45235;\n  --color-guide: #4D7E88;\n  --color-guide-bright: #4E91A1;\n  --color-guide-dark: #3F7380;\n  --color-energy: #5CCCF4;\n  --color-gold: #B58A43;\n  --color-gold-light: #D0A85A;\n  --color-brass: #8D6A35;\n  --color-success: #5C765D;\n  --color-disabled: #B7A383;\n\n  /* Backward-compatible project variables */\n  --font: var(--color-ink);\n  --bcg: var(--color-parchment);\n  --button: var(--color-midnight);\n  --pink: var(--color-danger);\n  --page: var(--color-paper);\n  --yellow: var(--color-gold-light);\n\n  color: var(--color-ink);\n  background: var(--color-parchment);\n  color-scheme: light;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n  margin: 0;\n}\n\nhtml {\n  background-color: var(--color-midnight);\n}\n\nbody {\n  font-family: var(--font-cyberfit);\n  color: var(--color-ink);\n  background-color: var(--color-parchment);\n  background-image:\n    radial-gradient(circle at 18% 12%, rgba(181, 138, 67, 0.14), transparent 34%),\n    radial-gradient(circle at 82% 88%, rgba(190, 77, 52, 0.10), transparent 32%),\n    linear-gradient(135deg, rgba(244, 231, 202, 0.24), rgba(216, 191, 146, 0.16));\n  background-attachment: fixed;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font: inherit;\n}\n\n\n/* Unified bilingual typography and overflow protection. */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n:where(h1, h2, h3, h4, h5, h6, p, li, label, button, a) {\n  min-width: 0;\n  max-width: 100%;\n  overflow-wrap: break-word;\n  word-break: normal;\n  hyphens: auto;\n}\n\n:where(h1, h2, h3, h4, h5, h6, button) {\n  text-wrap: balance;\n}\n\n:where(img, svg, video, canvas) {\n  max-width: 100%;\n}\n\n::selection {\n  color: var(--color-ivory);\n  background: var(--color-hero);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
